"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4408],{

/***/ 67546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ ecommerce_Faq_Faq; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(59740);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/molecules/Faq/index.js + 2 modules
var Faq = __webpack_require__(80001);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(25610);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Faq/Faq.js


var _excluded = ["title", "data"];





function Faq_Faq(_ref) {
  var _ref2;
  var _ref$static = _ref["static"],
    title = _ref$static.title,
    _ref$static$data = _ref$static.data,
    data = _ref$static$data === void 0 ? [] : _ref$static$data,
    props = (0,objectWithoutProperties/* default */.Z)(_ref$static, _excluded);
  var parsedData = (_ref2 = Array.isArray(data) ? data : []) == null ? void 0 : _ref2.map(function (_ref3) {
    var Answer = _ref3.Answer,
      Question = _ref3.Question;
    return {
      answer: Answer,
      question: Question
    };
  });
  return react.createElement(react.Fragment, null, title && react.createElement(Heading/* default */.Z, {
    "data-testid": "faq-title",
    color: "base",
    as: "h2",
    fontSize: 5,
    fontWeight: "bold",
    lineHeight: "display",
    m: "0 8px 12px"
  }, title), react.createElement(Faq/* default */.Z, (0,esm_extends/* default */.Z)({
    faq: parsedData
  }, props)));
}
Faq_Faq.defaultProps = {
  data: {},
  "static": {
    title: ''
  }
};
 false ? 0 : void 0;
Faq_Faq.ssr = true;
/* harmony default export */ var ecommerce_Faq_Faq = ((0,withLayoutProps/* default */.Z)(Faq_Faq));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/Faq/index.js


/***/ }),

/***/ 59106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ FastFilters_FastFilters; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/organisms/FastFilter/index.js + 2 modules
var FastFilter = __webpack_require__(90713);
// EXTERNAL MODULE: ../modules/build/esm/hocs/withLayoutProps.js
var withLayoutProps = __webpack_require__(89382);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 116 modules
var esm = __webpack_require__(6422);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var build_esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js
var taggedTemplateLiteral = __webpack_require__(71171);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(99673);
// EXTERNAL MODULE: ../../node_modules/@magalu/stereo-ui/build/esm/atoms/Box/index.js + 2 modules
var Box = __webpack_require__(84546);
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FastFilters/FastFilters.styles.js


var _templateObject;


var Container = (0,styled_components_browser_esm/* default */.ZP)(Box/* default */.Z).attrs(function (props) {
  return (0,esm_extends/* default */.Z)({}, props);
})(_templateObject || (_templateObject = (0,taggedTemplateLiteral/* default */.Z)(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FastFilters/FastFilters.js








var FastFilters = function FastFilters(_ref) {
  var data = _ref.data,
    structure = _ref.structure,
    staticProps = _ref["static"];
  var _ref2 = (data == null ? void 0 : data.search) || {},
    filtersData = _ref2.fastFilters;
  if (!filtersData) {
    return null;
  }
  var _usePublisher = (0,build_esm/* usePublisher */.Np)(),
    publish = _usePublisher.publish;
  var customCategoryFilter = false;
  var itemHeight = staticProps.itemHeight,
    itemWidth = staticProps.itemWidth,
    desktopMode = staticProps.desktopMode,
    slidesPerView = staticProps.slidesPerView;
  var parsedFilters = (0,esm/* filtersParser */.U8)({
    customCategoryFilter: customCategoryFilter,
    data: data,
    filters: filtersData,
    query: {},
    removeFilters: [],
    structure: structure
  });
  var onFilterItemClick = function onFilterItemClick(e, filter) {
    var _filter$values;
    e.preventDefault();
    var filters = ((_filter$values = filter.values) == null ? void 0 : _filter$values.length) ? filter.href.replace("".concat(filter.filterSlug, "---").concat(filter.slug), "".concat(filter.filterSlug, "---").concat(filter.values.join('--'))) : filter.href;
    publish('productlist:fastFilter:click', (0,esm_extends/* default */.Z)({}, filter, {
      custom: false
    }));
    (0,esm/* routePush */.dY)({
      path: filters,
      spa: true
    });
  };
  var onFilterView = function onFilterView(_ref3) {
    var _attributeFilters$, _attributeFilters$$va, _attributeFilters$$va2;
    var filters = _ref3.filters;
    var attributeFilters = filters.attributeFilters;
    var eventLabel = (_attributeFilters$ = attributeFilters[0]) == null ? void 0 : (_attributeFilters$$va = _attributeFilters$.values) == null ? void 0 : (_attributeFilters$$va2 = _attributeFilters$$va.flatMap(function (item, idx) {
      return "".concat(idx + 1, "\xB0").concat(item.label, ":").concat(item.slug);
    })) == null ? void 0 : _attributeFilters$$va2.join(';');
    publish('productlist:fastFilter:view', {
      custom: false,
      eventLabel: eventLabel
    });
  };
  return react.createElement(react.Fragment, null, filtersData && react.createElement(Container, null, react.createElement(FastFilter/* default */.Z, {
    filters: parsedFilters,
    onItemClick: onFilterItemClick,
    onView: onFilterView,
    desktopMode: desktopMode,
    itemHeight: itemHeight,
    itemWidth: itemWidth,
    slidesPerView: slidesPerView
  })));
};
 false ? 0 : void 0;
FastFilters.displayName = 'FastFilters';
FastFilters.defaultProps = {
  data: {},
  "static": {},
  structure: {}
};
FastFilters.ssr = true;
/* harmony default export */ var FastFilters_FastFilters = ((0,withLayoutProps/* default */.Z)(FastFilters));
;// CONCATENATED MODULE: ../modules/build/esm/components/ecommerce/FastFilters/index.js


/***/ })

}]);